import { Injectable } from '@angular/core';
import { ComponentBase } from '../../../component-base';
import { MatDialog } from '@angular/material';
import { DrawingsHolderService } from '../drawings-holder.service';
import { SelectablePicket } from '../object3D';
import { IDoubleClick } from '../Interfaces';
import { DeleteObjectComponent } from './DeleteObjectComponent';
import { PicketEditorComponent } from '../ng-components/picket-editor/picket-editor.component';
import { DataForDisplayingMenuItemsService } from '../../data-for-displaying-menu-items.service';
import { PostTextGetterComponent } from '../ng-components/post-text-getter/post-text-getter.component';

declare const THREE: any;

@Injectable()
export class EditPicketComponent extends ComponentBase implements IDoubleClick {
  loader = new THREE.ImageLoader();
  selectedObject = [null];
  currentChoises: any;

  constructor(
    private dataForMenu: DataForDisplayingMenuItemsService,
    private dialog: MatDialog,
    private drawings: DrawingsHolderService,
    private deleteComponent: DeleteObjectComponent
  ) {
    super();
    this.disable();
    this.drawings.onSelect.subscribe(obj => {
      if (obj) {
        this.selectedObject = obj[0] instanceof SelectablePicket ? obj : [null];
      } else {
        this.selectedObject = [null];
      }
    });
  }

  dblclick(e: MouseEvent) {
    if (this.selectedObject[0]) {
      this.currentChoises = this.dataForMenu.getCurrentParams();
      let infill = this.currentChoises.infill;

      if (
        infill === 'verticalCable' ||
        infill === 'horizontalCableBaserail' ||
        infill === 'horizontalCable'
      ) {
        let postType;

        if (this.selectedObject[0] instanceof SelectablePicket) {
          postType = this.selectedObject[0].type;
        }

        let labelPosition = this.selectedObject[0].labelPos
          ? this.selectedObject[0].labelPos
          : 'Center';

        let text = this.selectedObject[0].text ? this.selectedObject[0].text : '';

        const dialogRef = this.dialog.open(PicketEditorComponent, {
          data: {
            postType: postType,
            labelPosition: labelPosition
          },
          width: '250px'
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.selectedObject.forEach(obj => {
              obj.modifiedAtStep3 = true;
              obj.children
                .filter(ch => ch.name === 'text')
                .forEach(ch => {
                  obj.remove(ch);
                });
              obj.children
                .filter(ch => ch.name === 'textPost')
                .forEach(ch => {
                  obj.remove(ch);
                });

              if (result.postType === 'TP') {
                const textDialogRef = this.dialog.open(PostTextGetterComponent, {
                  data: {
                    text: text
                  },
                  width: '250px'
                });

                textDialogRef.afterClosed().subscribe(res => {
                  if (res.text && res.text !== '') {
                    obj.addEditableLabel(result, res.text);
                  }
                });
              } else {
                this.loader.load(
                  '../../../../../../assets/images/scene-plan/' +
                    result.postType.toLowerCase() +
                    '.png',
                  picture => {
                    obj.addLabel(result, picture);
                  }
                );
              }
            });
          }
        });
        return true;
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/EditPicketComponent.ts